// extracted by mini-css-extract-plugin
module.exports = {"banner":"ErrorBanner_banner__ebCoo","text":"ErrorBanner_text__20iTX","close":"ErrorBanner_close__2aQAv"};